module.exports = __webpack_public_path__ + "img/worry_about_risks.8dfcdda3.svg";